



import { defineComponent, onMounted, watch } from '@vue/composition-api';
import config from '@/config';

// eslint-disable-next-line @typescript-eslint/naming-convention
const { CaptchaAppId } = config;

export default defineComponent({
  name: 'TCaptcha',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    destroy: {
      type: Boolean,
      default: false,
    },
    captchaId: {
      type: String,
      default: '',
    },
  },
  setup(prop: any, { emit }: any) {
    let captcha: any;

    const callback = (res: any) => {
      /* res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
        res（客户端出现异常错误 仍返回可用票据） = {ret: 0, ticket: "String",
        randstr: "String", errorCode: Number, errorMessage: "String"}
        res（用户主动关闭验证码）= {ret: 2}
      */
      if (res.ticket) {
        emit('captcha', res);
        console.log(res);
        // 上传票据 可根据errorCode和errorMessage做特殊处理或统计
      }
    };

    // 验证码js加载错误处理
    const loadErrorCallback = () => {
      /* 生成票据或自行做其它处理 */
      const ticket = `terror_1001_${CaptchaAppId}${Math.floor(
        new Date().getTime() / 1000,
      )}`;
      callback({
        ret: 0,
        randstr: `@${Math.random().toString(36).substr(2)}`,
        ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error',
      });
    };

    const init = () => {
      try {
        captcha = new (window as any).TencentCaptcha(
          document.getElementById(prop.captchaId),
          CaptchaAppId,
          callback,
          { bizState: '自定义透传参数', type: 'embed' },
        );

        if (prop.show) {
          captcha.show();
        }
      } catch (error) {
        console.log(error);
        loadErrorCallback();
      }
    };

    const loadScript = (url: string) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;

        script.onload = () => resolve(script);
        script.onerror = () =>
          reject(new Error(`Script load error for ${url}`));

        document.body.appendChild(script);
      });

    onMounted(async () => {
      if (typeof (window as any).TencentCaptcha !== 'function') {
        await loadScript('https://turing.captcha.qcloud.com/TCaptcha.js');
        init();
      } else {
        init();
      }
    });

    watch(
      () => prop.show,
      (val: boolean) => {
        if (val && captcha) {
          captcha.show();
        }
      },
    );

    watch(
      () => prop.destroy,
      (val: boolean) => {
        if (val && captcha) {
          captcha.destroy();
        }
      },
    );
  },
});
